// extracted by mini-css-extract-plugin
module.exports = {"professional-skills-unit":"professional-skills-showcase_professional-skills-unit__n4FBR","panel-content":"professional-skills-showcase_panel-content__60msX"};